import React from "react";

export const EventsTableHead = (props) => {
  return (
    <tr>
      <th style={{ width: "20%" }}>Event</th>
      <th style={{ width: "15%" }}>Start/End date</th>
      <th style={{ width: "8%" }}>
        Viewed/ <br />
        Used
      </th>
      <th style={{ width: "10%" }}>
        Live Stream
        <br />
        Viewed
      </th>
      <th style={{ width: "8%" }}>
        Pending
        <br /> Requests
      </th>
      <th style={{ width: "8%" }}>
        Tickets
        <br /> Booked
      </th>
      <th style={{ width: "4%" }}>RSVP</th>
      <th style={{ width: "6%" }}>Primary</th>
      <th style={{ width: "6%" }}>Status</th>
      <th style={{ width: "15%" }}>Status</th>
    </tr>
  );
};
